import axios from 'axios'
import { Toast } from '@nutui/nutui'
import router from '@/router'
import Storage from '@/utils/storage'

window.axiosCancel = []

axios.defaults.withCredentials = true
// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  withCredentials: false, // 跨域请求时发送 cookies
  timeout: 5000 // request timeout
})

// 获取CancelToken
const CancelToken = axios.CancelToken

// request interceptor
service.interceptors.request.use(
  config => {
    config.headers.Authorization = localStorage.jwtToken
    config.cancelToken = new CancelToken(cancel => {
      window.axiosCancel.push({
        cancel
      })
    })
    return config
  },
  error => {
    // do something with request error
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    if (response.status === 200) {
      // if (response.config.url == '/soubao/index/auth') {
      //   res.cookie = response.headers['set-cookie'];
      //   let allCookies = document.cookie
      // }
      return res
    } else {
      Toast(res.msg || '网络出错，请稍后重试！')
      return Promise.reject(new Error(res.msg || '网络出错，请稍后重试！'))
    }
  },
  error => {
    if (axios.isCancel(error)) {
      return new Promise(() => {
      })
    } else {
      const err = error.message
      const status = err.replace(/[^0-9]/gi, '')
      if (status === '401') {
        Storage.localRemove('jwtToken')
        Toast.fail('认证已过期 请重新登录')
        router.go(0)
      } else if (status === '5000') {
        Toast.fail('网络请求超时，请稍后重试！')
        return Promise.reject(error)
      } else {
        Toast.fail(error.message)
        return Promise.reject(error)
      }
    }
  }
)

export default service
